module.exports = __webpack_public_path__ + "static/cone_of_cold-67d8741376d823da66a5917a25088ad8.webp";